// extracted by mini-css-extract-plugin
module.exports = {"dialog__img":"DataInProgress_dialog__img__--Qns","dialog__text":"DataInProgress_dialog__text__3AsHv","dialog__action":"DataInProgress_dialog__action__3JNc2"};